import { ActionType } from "../action-types/type";

import { AuthAction } from "../actions/index";
import authStorage from "../../services/authStorage";

const user = authStorage.read();

const initialState = user
  ? { isLoggedIn: true, user }
  : { isLoggedIn: false, user: null };

export function authReducer(state: any = initialState, action: AuthAction) {
  switch (action.type) {
    case ActionType.REGISTER_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
      };
    case ActionType.REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false,
      };
    case ActionType.LOGIN_SUCCESS:
      const loginState = {
        ...state,
        isLoggedIn: true,
        user: {
          userName: action.payload.user.userName,
          issueDate: action.payload.user.issueDate,
          expirationDate: action.payload.user.expirationDate,
          status: action.payload.user.status,
          message: action.payload.user.message,
          path: action.payload.user.path,
          token: action.payload.user.token,
          // NB: the refresh token is intentionally NOT persisted; it lives in
          // an HttpOnly cookie. We only keep the access token client-side.
          roles: [...action.payload.user.roles],
          preferredLanguage: action.payload.user.preferredLanguage,
        },
      };
      authStorage.save(loginState.user);
      localStorage.setItem("language", loginState.user.preferredLanguage);
      return { ...loginState };
    case ActionType.REFRESH_TOKEN_SUCCESS:
      // /api/auth/refresh returns a fresh access token and the current roles
      // (the refresh token is rotated in the HttpOnly cookie, never in JS).
      // Merge them into the existing user and persist so the session continues.
      const refreshedUser = {
        ...state.user,
        issueDate: action.payload.user.issueDate,
        expirationDate: action.payload.user.expirationDate,
        token: action.payload.user.token,
        roles: action.payload.user.roles
          ? [...action.payload.user.roles]
          : state.user?.roles,
      };
      authStorage.save(refreshedUser);
      return { ...state, isLoggedIn: true, user: refreshedUser };
    case ActionType.LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case ActionType.LOGOUT:
      // Wipe the persisted tokens on every logout path, not just via the
      // logout() thunk, so a direct LOGOUT dispatch (e.g. from the refresh
      // interceptor) can never leave a stale token in storage.
      authStorage.clear();
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case ActionType.UPDATE_USER_ROLES:
      return {
        ...state,
        user: { ...state.user, roles: [...action.payload.roles] },
      };
    default:
      return state;
  }
}
